import React from "react"

const BonusTrendChart = ({ trend }) => {
  const max = Math.max(...trend.days.map(d => d.value), 1)

  return (
    <div className="d-flex align-items-end gap-3" style={{ height: 150 }}>
      {trend.days.map(({ day, value }) => (
        <div key={day} className="flex-fill d-flex flex-column align-items-center justify-content-end h-100 gap-2">
          <div className="font-size-11 fw-bold text-muted">{value}</div>
          <div
            className="w-100 rounded-top"
            style={{
              maxWidth: 34,
              height: `${(value / max) * 100}%`,
              backgroundColor: value === max ? "#556ee6" : "#c3ccf4",
            }}
          />
          <div className="font-size-11 text-muted">{day}</div>
        </div>
      ))}
    </div>
  )
}

export default BonusTrendChart
